import { Suspense } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import DashboardRoutes from "./routes/DashboardRoutes";
import LandingRoutes from "./routes/LandingRoutes";
import { selectLoginStatus } from "./state/slices/loginSlice";
import Alert from "./utils/Alert";
import Loader from "./utils/Loader";
import Tostify from "./utils/Tostify";

function App() {
  const loginState = useSelector(selectLoginStatus);
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Loader />
        <Alert />
        {loginState ? <DashboardRoutes /> : <LandingRoutes />}
        <Tostify />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
